/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class RestoreRdsInstanceConfig {
  /**
  * ID of the key you want Eon to use for encrypting the restored database.
  */
  'encryptionKeyId'?: string;
  /**
  * List of security group IDs to associate with the restored database. Must be in the same VPC of `subnetGroup`. 
  */
  'securityGroups'?: Array<string>;
  /**
  * Subnet group ID to associate with the restored database. Must be in the same VPC of `securityGroup`. 
  */
  'subnetGroup'?: string;
  /**
  * Tags to apply to the restored database as key-value pairs, where key and value are both strings.  **Example:** `{\"eon_api_restore\": \"true\"}` 
  */
  'tags'?: { [key: string]: string; };
  /**
  * List of specific databases that were selected for restore. If empty or null, the entire RDS instance was restored. 
  */
  'databaseFilter'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "encryptionKeyId",
      "baseName": "encryptionKeyId",
      "type": "string",
      "format": ""
    },
    {
      "name": "securityGroups",
      "baseName": "securityGroups",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "subnetGroup",
      "baseName": "subnetGroup",
      "type": "string",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "databaseFilter",
      "baseName": "databaseFilter",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreRdsInstanceConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

